/* MACONDO – restyle following the editorial mockups (header, search, collection, product, cart). */
(function () {
  var desk = window.matchMedia('(min-width: 750px)');
  var main = document.querySelector('main');
  var tpl = (main && main.dataset.template) || '';

  /* ---------- helpers ---------- */
  var SMALL = { de: 1, des: 1, du: 1, da: 1, di: 1, la: 1, le: 1, les: 1, x: 1, and: 1, et: 1, von: 1 };
  function keepUpper(w) { return /\./.test(w) || /^[A-Z0-9&]{1,3}$/.test(w) && /\d|&/.test(w); }
  function titleCase(s) {
    return s.trim().split(/(\s+)/).map(function (w, i) {
      if (/^\s+$/.test(w) || !w) return w;
      if (keepUpper(w)) return w;
      var l = w.toLocaleLowerCase();
      if (i > 0 && SMALL[l]) return l;
      return l.charAt(0).toLocaleUpperCase() + l.slice(1);
    }).join('');
  }
  function sentenceCase(s) {
    var first = true;
    return s.trim().split(/(\s+)/).map(function (w) {
      if (/^\s+$/.test(w) || !w) return w;
      if (keepUpper(w)) { first = false; return w; }
      var l = w.toLocaleLowerCase();
      if (first) { first = false; return l.charAt(0).toLocaleUpperCase() + l.slice(1); }
      return l;
    }).join('');
  }
  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    return '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
  }
  function parseMoney(t) {
    var m = (t || '').replace(/[^\d,.]/g, '');
    if (!m) return NaN;
    return parseFloat(m.replace(/\./g, '').replace(',', '.'));
  }
  function observe(fn) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; try { fn(); } catch (e) {} });
    }).observe(document.body, { childList: true, subtree: true });
    try { fn(); } catch (e) {}
  }
  function brandMap() {
    var map = {};
    document.querySelectorAll('marquee-component a[href*="/collections/"]').forEach(function (a) {
      map[a.textContent.trim().toUpperCase()] = a.getAttribute('href');
    });
    return map;
  }

  /* ---------- product cards: "Miu Miu" / "Nappa Leather Pocket Bag" / (-20%) ---------- */
  function enhanceCards() {
    document.querySelectorAll('product-card .text-block strong:not([data-m-tc])').forEach(function (s) {
      s.setAttribute('data-m-tc', '1');
      s.textContent = titleCase(s.textContent);
    });
    document.querySelectorAll('product-card product-price.text-block:not([data-m-off])').forEach(function (p) {
      p.setAttribute('data-m-off', '1');
      var was = p.querySelector('.compare-at-price'), now = p.querySelector('.price');
      if (!was || !now) return;
      var a = parseMoney(was.textContent), b = parseMoney(now.textContent);
      if (!(a > b)) return;
      var off = document.createElement('span');
      off.className = 'm-off';
      off.textContent = '(-' + Math.round((1 - b / a) * 100) + '%)';
      now.parentNode.insertBefore(off, now);
    });
  }

  /* ---------- header: text links + marquee that stays under the header ---------- */
  function initHeader() {
    var marquee = main && main.querySelector('marquee-component');
    var header = document.querySelector('#header-group header-component, header-component');
    if (!marquee || !header) return;
    var bar = document.createElement('div');
    bar.className = 'm-sticky-marquee';
    bar.setAttribute('aria-hidden', 'true');
    var clone = marquee.cloneNode(true);
    clone.removeAttribute('data-ready');
    bar.appendChild(clone);
    document.body.appendChild(bar);
    var ticking = false;
    function check() {
      ticking = false;
      if (!desk.matches) { bar.classList.remove('is-on'); return; }
      var live = main.querySelector('marquee-component') || marquee;
      if (!live.isConnected) { bar.classList.remove('is-on'); return; }
      var hb = header.getBoundingClientRect().bottom;
      var mb = live.getBoundingClientRect().bottom;
      bar.style.top = Math.max(0, Math.round(hb)) + 'px';
      bar.classList.toggle('is-on', mb < hb);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- search: centred box, GO, suggestions ---------- */
  var SUGGEST = [
    ['New arrivals', '/collections/new-arrivals'],
    ['Bags', '/collections/all?filter.p.product_type=gid%3A%2F%2Fshopify%2FFilterSettingGroup%2F272793937'],
    ['Sale', '/collections/sales'],
    ['Shoes', '/collections/all?filter.p.product_type=gid%3A%2F%2Fshopify%2FFilterSettingGroup%2F272859473']
  ];
  function initSearch() {
    var modal = document.getElementById('search-modal');
    if (!modal) return;
    function setup() {
      var form = modal.querySelector('.predictive-search-form');
      if (!form || form.querySelector('.m-sm-title')) return;
      var head = form.querySelector('.predictive-search-form__header');
      var t = document.createElement('p');
      t.className = 'm-sm-title';
      t.textContent = 'Search';
      form.insertBefore(t, head);
      var input = form.querySelector('input.search-input');
      if (input) input.setAttribute('placeholder', 'Search for an item, colour, brands, …');
      var inner = form.querySelector('.predictive-search-form__header-inner');
      if (inner) {
        var go = document.createElement('button');
        go.type = 'submit';
        go.className = 'm-sm-go';
        go.textContent = 'Go';
        inner.appendChild(go);
      }
      var wrap = form.querySelector('.predictive-search-form__content-wrapper') || form;
      var sg = document.createElement('div');
      sg.className = 'm-sm-sugg';
      sg.innerHTML = '<p class="m-sm-sugg__title">Suggestions</p>' + SUGGEST.map(function (s) {
        return '<a href="' + s[1] + '">' + s[0] + '</a>';
      }).join('');
      wrap.parentNode.insertBefore(sg, wrap);
      function sync() { modal.classList.toggle('m-sm-typing', !!(input && input.value.trim())); }
      if (input) input.addEventListener('input', sync);
      sync();
    }
    setup();
    new MutationObserver(function () { try { setup(); } catch (e) {} }).observe(modal, { childList: true, subtree: true });
  }

  /* ---------- collection page (desktop): crumbs + inline sort + plain filter lists + description ---------- */
  var descCache = {};
  function initCollection() {
    if (tpl.indexOf('collection') !== 0) return;
    var titleSec = main.querySelector(':scope > .shopify-section[id$="__section"]');
    var crumbSec = main.querySelector(':scope > .shopify-section[id*="__breadcrumb"]');
    if (titleSec) titleSec.classList.add('m-col-title');
    if (crumbSec) crumbSec.classList.add('m-col-crumbs');
    var ownDesc = titleSec && titleSec.querySelector('.text-block.h4');
    var ownDescHTML = ownDesc ? ownDesc.innerHTML : '';
    var crumbLinks = crumbSec ? Array.prototype.slice.call(crumbSec.querySelectorAll('a')) : [];
    var colTitle = '';
    if (crumbSec) {
      var parts = crumbSec.innerText.split('/').map(function (x) { return x.trim(); }).filter(Boolean);
      colTitle = parts[parts.length - 1] || '';
    }
    var colUrl = location.pathname;
    var brands = brandMap();

    function checked(param) {
      return Array.prototype.slice.call(document.querySelectorAll('.facets--vertical:not(.facets--drawer) input[name="' + param + '"]:checked')).map(function (i) {
        var l = i.closest('.checkbox, li');
        var t = l ? (l.querySelector('.checkbox__label-text') || l).textContent.trim() : i.value;
        return { value: i.value, label: i.getAttribute('data-label') || t };
      });
    }
    function urlWith(params) {
      var u = new URL(colUrl, location.origin);
      params.forEach(function (p) { u.searchParams.append(p[0], p[1]); });
      return u.pathname + u.search;
    }

    function build() {
      if (!desk.matches) return;
      var bar = main.querySelector('.collection-wrapper > .facets--horizontal');
      var grid = main.querySelector('.main-collection-grid > div');
      if (!bar || !grid) return;

      /* names + order of the sidebar lists */
      document.querySelectorAll('.facets--vertical:not(.facets--drawer) accordion-custom[data-filter-param-name]').forEach(function (acc) {
        var p = acc.getAttribute('data-filter-param-name');
        var lab = acc.querySelector('.facets__summary .facets__label');
        if (/product_type/.test(p)) { acc.classList.add('m-f-cat', 'm-f-open'); if (lab && lab.textContent !== 'Categories') lab.textContent = 'Categories'; }
        else if (/vendor/.test(p)) { acc.classList.add('m-f-brand', 'm-f-open'); if (lab && lab.textContent !== 'Designers') lab.textContent = 'Designers'; }
        acc.querySelectorAll('.checkbox__label-text:not([data-m-sc])').forEach(function (s) {
          s.setAttribute('data-m-sc', '1');
          s.textContent = sentenceCase(s.textContent);
        });
        if (/vendor/.test(p)) {
          var inp = acc.querySelector('.m-bs-input');
          var n = acc.querySelectorAll('.facets__inputs-list-item').length;
          if (inp && n && inp.getAttribute('placeholder') !== 'Search ' + n + ' brands') inp.setAttribute('placeholder', 'Search ' + n + ' brands');
        }
      });

      var cats = checked('filter.p.product_type');
      var vends = checked('filter.p.vendor');

      /* breadcrumb */
      var html = '';
      var items = [['Home', '/']];
      if (crumbLinks.length > 1) items = crumbLinks.map(function (a) { return [a.textContent.trim(), a.getAttribute('href')]; });
      if (colTitle && items[items.length - 1][0].toUpperCase() !== colTitle.toUpperCase()) items.push([colTitle, colUrl]);
      if (cats.length === 1) items.push([cats[0].label, urlWith([['filter.p.product_type', cats[0].value]])]);
      if (vends.length === 1) items.push([vends[0].label, '']);
      html = items.map(function (it, i) {
        var last = i === items.length - 1;
        return (i ? '<span class="m-crumbs__sep">/</span>' : '') + (last || !it[1] ? '<span>' + it[0] + '</span>' : '<a href="' + it[1] + '">' + it[0] + '</a>');
      }).join('');
      var crumbs = bar.querySelector('.m-crumbs');
      if (!crumbs) { crumbs = document.createElement('nav'); crumbs.className = 'm-crumbs'; crumbs.setAttribute('aria-label', 'Breadcrumb'); bar.insertBefore(crumbs, bar.firstChild); }
      if (crumbs.innerHTML !== html) crumbs.innerHTML = html;

      /* inline sort */
      var sel = bar.querySelector('select.sorting-filter__select') || document.querySelector('select.sorting-filter__select');
      var sort = bar.querySelector('.m-sort');
      if (!sort && sel) {
        sort = document.createElement('div');
        sort.className = 'm-sort';
        var opts = [['created-descending', 'Latest arrivals'], ['price-ascending', 'Ascending price'], ['price-descending', 'Descending price']];
        sort.innerHTML = '<span class="m-sort__label">Sort by</span>' + opts.map(function (o) {
          return '<button type="button" data-v="' + o[0] + '">' + o[1] + '</button>';
        }).join('');
        sort.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (!b) return;
          var u = new URL(location.href);
          u.searchParams.set('sort_by', b.getAttribute('data-v'));
          u.searchParams.delete('page');
          location.assign(u.toString());
        });
        bar.appendChild(sort);
      }
      if (sort) {
        var cur = new URL(location.href).searchParams.get('sort_by') || (sel ? sel.value : '');
        sort.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-v') === cur); });
      }

      /* description under the crumbs */
      var box = grid.querySelector('.m-cdesc');
      if (!box) { box = document.createElement('div'); box.className = 'm-cdesc'; grid.insertBefore(box, grid.firstChild); }
      var key, want;
      if (vends.length === 1) {
        var href = brands[vends[0].label.toUpperCase()] || brands[vends[0].value.toUpperCase()];
        key = 'b:' + (href || vends[0].value);
        if (href && href !== colUrl) {
          if (descCache[href] === undefined) {
            descCache[href] = null;
            fetch(href).then(function (r) { return r.text(); }).then(function (t) {
              var d = new DOMParser().parseFromString(t, 'text/html');
              var el = d.querySelector('main > .shopify-section[id$="__section"] .text-block.h4');
              descCache[href] = el ? el.innerHTML : '';
              build();
            }).catch(function () { descCache[href] = ''; });
          }
          want = descCache[href] ? descCache[href] + '<a class="m-cdesc__link" href="' + href + '">See all ' + vends[0].label + ' products</a>' : '';
        } else want = ownDescHTML;
      } else if (!cats.length && !vends.length) {
        key = 'own'; want = ownDescHTML;
      } else { key = 'none'; want = ''; }
      if (box.getAttribute('data-k') !== key || box.getAttribute('data-l') !== String((want || '').length)) {
        box.setAttribute('data-k', key);
        box.setAttribute('data-l', String((want || '').length));
        box.innerHTML = want || '';
        box.hidden = !want;
      }
    }
    observe(build);
    desk.addEventListener && desk.addEventListener('change', build);
  }

  /* ---------- product page: tabs under the product (more from brand / similar / also like / last visited) ---------- */
  function cardHTML(p) {
    var price = p.price, cmp = p.compare;
    var off = cmp && cmp > price ? '<span class="m-off">(-' + Math.round((1 - price / cmp) * 100) + '%)</span>' : '';
    return '<li class="m-rel__card"><a href="' + p.url + '">' +
      '<span class="m-rel__img">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="m-rel__brand">' + titleCase(p.vendor || '') + '</span>' +
      '<span class="m-rel__title">' + p.title + '</span>' +
      '<span class="m-rel__price">' + (off ? '<s>' + money(cmp) + '</s> ' + off + ' ' : '') + money(price) + '</span>' +
      '</a></li>';
  }
  function imgSize(src, w) {
    if (!src) return '';
    if (/^\/\//.test(src)) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fromJSON(p) {
    var v = (p.variants || [])[0] || {};
    var price = typeof p.price === 'number' ? p.price : Math.round(parseFloat(v.price || 0) * 100);
    var cmp = typeof p.compare_at_price === 'number' ? p.compare_at_price : (v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0);
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    var t = p.title || '';
    if (p.vendor && t.toUpperCase().indexOf(p.vendor.toUpperCase() + ' ') === 0) t = t.slice(p.vendor.length + 1);
    return { id: p.id, url: '/products/' + p.handle, title: t, vendor: p.vendor, price: price, compare: cmp, img: imgSize(typeof img === 'string' ? img : img.src, 600) };
  }
  function initRelated() {
    if (tpl.indexOf('product') !== 0) return;
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var rec = document.querySelector('product-recommendations');
    if (!meta || !rec) return;
    var sec = rec.closest('.shopify-section') || rec;
    var pid = String(meta.id), vendor = meta.vendor || '';

    /* remember this product for "Last visited" */
    var og = function (p) { var m = document.querySelector('meta[property="' + p + '"]'); return m ? m.content : ''; };
    var priceEl = document.querySelector('main product-price');
    var cur = {
      id: pid, url: location.pathname, vendor: vendor,
      title: (og('og:title') || document.title).split('|')[0].replace(new RegExp('^' + vendor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i'), '').trim(),
      price: Math.round(parseMoney(priceEl && priceEl.querySelector('.price') ? priceEl.querySelector('.price').textContent : '') * 100) || 0,
      compare: Math.round(parseMoney(priceEl && priceEl.querySelector('.compare-at-price') ? priceEl.querySelector('.compare-at-price').textContent : '') * 100) || 0,
      img: imgSize(og('og:image').replace(/^http:/, 'https:'), 600)
    };
    var seen = [];
    try { seen = JSON.parse(localStorage.getItem('m-last-visited') || '[]'); } catch (e) {}
    var before = seen.filter(function (p) { return p.id !== pid; });
    try { localStorage.setItem('m-last-visited', JSON.stringify([cur].concat(before).slice(0, 12))); } catch (e) {}

    var box = document.createElement('div');
    box.className = 'm-rel';
    box.innerHTML = '<div class="m-rel__nav" role="tablist"></div><div class="m-rel__panels"></div>';
    sec.appendChild(box);
    sec.classList.add('m-rel-host');
    var nav = box.querySelector('.m-rel__nav'), panels = box.querySelector('.m-rel__panels');
    var tabs = [];
    function addTab(label, list) {
      list = (list || []).filter(function (p) { return String(p.id) !== pid && p.url; }).slice(0, 5);
      if (!list.length) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.textContent = label;
      var ul = document.createElement('ul');
      ul.className = 'm-rel__grid';
      ul.innerHTML = list.map(cardHTML).join('');
      nav.appendChild(b);
      panels.appendChild(ul);
      var n = tabs.length;
      tabs.push([b, ul]);
      b.addEventListener('pointerdown', function (e) { if (e.button === 0) sel(n); });
      b.addEventListener('click', function () { sel(n); });
    }
    function sel(n) {
      tabs.forEach(function (t, i) {
        t[0].classList.toggle('is-active', i === n);
        t[0].setAttribute('aria-selected', i === n ? 'true' : 'false');
        t[1].hidden = i !== n;
      });
    }

    var brandHref = brandMap()[vendor.toUpperCase()];
    var j = function (u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); };
    Promise.all([
      brandHref ? j(brandHref + '/products.json?limit=12') : Promise.resolve({}),
      j('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related'),
      j('/recommendations/products.json?product_id=' + pid + '&limit=5&intent=complementary')
    ]).then(function (r) {
      var brandList = (r[0].products || []).map(fromJSON);
      var related = (r[1].products || []).map(fromJSON);
      var compl = (r[2].products || []).map(fromJSON);
      var similar = related.slice(0, 5);
      var also = compl.length ? compl : related.slice(5, 10);
      addTab('More from ' + titleCase(vendor), brandList);
      addTab('Similar products', similar);
      addTab('You might also like', also);
      addTab('Last visited', before);
      if (tabs.length) { sel(0); sec.classList.add('m-rel-ready'); }
      else box.remove();
    });
  }

  /* ---------- cart drawer: Antonia-style labels ---------- */
  function enhanceCartText() {
    document.querySelectorAll('.cart-drawer .cart__total-label:not([data-m])').forEach(function (l) {
      l.setAttribute('data-m', '1');
      l.textContent = 'Subtotal';
    });
    /* footer newsletter: "Subscribe" under the email line */
    document.querySelectorAll('.shopify-section-group-footer-group .email-signup__button:not([data-m])').forEach(function (b) {
      b.setAttribute('data-m', '1');
      var label = b.querySelector('span:not(.svg-wrapper):not(.visually-hidden)');
      if (label) label.textContent = 'Subscribe';
      else {
        var t = Array.prototype.slice.call(b.childNodes).filter(function (n) { return n.nodeType === 3 && n.nodeValue.trim(); })[0];
        if (t) t.nodeValue = 'Subscribe';
        else b.appendChild(document.createTextNode('Subscribe'));
      }
    });
  }

  function init() {
    try { initHeader(); } catch (e) {}
    try { initSearch(); } catch (e) {}
    try { initCollection(); } catch (e) {}
    try { initRelated(); } catch (e) {}
    observe(function () { enhanceCards(); enhanceCartText(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
